export default "<div class=\"coworking {{size}}\">\n  <ng-container *ngIf=\"imgSrc\">\n    <img [src]=\"imgSrc\" alt=\"\">\n  </ng-container>\n</div>\n";